@if (detailRows().length) {
  <mat-accordion class="w-full">
    <mat-expansion-panel>
      <mat-expansion-panel-header class="px-3">
        <mat-panel-title>
          {{ 'time-registration-details.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <dl class="grid grid-cols-2 gap-x-4 gap-y-3 px-3 pb-3">
        @for (row of detailRows(); track row.id) {
          <div class="flex min-w-0 flex-col">
            <dt class="text-xs text-slate-500">{{ row.labelKey | translate }}</dt>
            <dd class="m-0 text-sm font-medium text-slate-900 break-words">
              @if (row.valueKey) {
                {{ row.valueKey | translate }}
              } @else if (row.value) {
                {{ row.value }}
              } @else {
                <span class="font-normal text-slate-400 italic">
                  {{ 'time-registration-details.not-specified' | translate }}
                </span>
              }
            </dd>
          </div>
        }
      </dl>
    </mat-expansion-panel>
  </mat-accordion>
}